import { Typography } from "@mui/material";
import React, { FC, ReactElement } from "react";

const RequestsItemLayout: FC<any> = ({
  width,
  title,
  fontWeight = "normal",
  color = "primary",
}: any): ReactElement => {
  return (
    <div
      style={{
        width: width + "px",
      }}
    >
      <Typography fontWeight={fontWeight} color={color}>
        {title}
      </Typography>
    </div>
  );
};

export default RequestsItemLayout;
